import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  type SessionAttendanceListFilter,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { attendanceKeys } from './keys';

export type ReturnTypeFromUseSessionAttendanceList = UseQueryReturnType<
  typeof useSessionAttendanceList
>[number];

const sessionAttendanceListRequest = graphql(/* GraphQL */ `
  query attendance_sessionAttendanceReport(
    $filter: SessionAttendanceListFilter
  ) {
    attendance_sessionAttendanceList(filter: $filter) {
      id
      studentPartyId
      attendanceCode {
        id
        code
        name
      }
      student {
        person {
          partyId
          firstName
          lastName
          avatarUrl
          type
          title {
            id
            name
            nameTextId
          }
        }
        extensions {
          priority
          aen
          medical
        }
        yearGroups {
          name
        }
      }
      bellTime {
        id
        time
        name
      }
      attendanceCodeId
      classGroup {
        name
      }
      date
      note
    }
  }
`);

const sessionListQuery = (filter: SessionAttendanceListFilter) => ({
  queryKey: attendanceKeys.sessionAttendanceList(filter),
  queryFn: () => gqlClient.request(sessionAttendanceListRequest, { filter }),
});

export function getSessionAttendanceList(filter: SessionAttendanceListFilter) {
  return queryClient.fetchQuery(sessionListQuery(filter));
}

export function useSessionAttendanceList(filter: SessionAttendanceListFilter) {
  return useQuery({
    ...sessionListQuery(filter),
    placeholderData: keepPreviousData,
    select: ({ attendance_sessionAttendanceList }) =>
      attendance_sessionAttendanceList,
  });
}

export function getAbsentRequests(filter: SessionAttendanceListFilter) {
  return queryClient.fetchQuery(sessionListQuery(filter));
}
